<template>
    <v-container style="padding-top: 70px;">
        <div v-if="showcargando == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-row>
            <v-card flat class="text-xs-center ma-3" width="100%">
                <v-card-title class=" primary">
                    <span class="card-title-text" style="color: white;">Alta Poder</span>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" v-model="validForm" lazy-validation>
                        <v-row justify="center">
                            <v-col cols="12" md="6">
                                <vs-list>
                                    <label class="typo__label" style="text-align: center;">Número de escritura:</label>
                                    <v-text-field v-model="escritura"
                                                  maxlength="6"
                                                  outlined
                                                  dense
                                                  @keypress="filter($event)"
                                                  @keydown.enter.prevent
                                                  :rules="[rules.required, rules.numero]">
                                    </v-text-field>
                                </vs-list>
                                <vs-list>
                                    <label class="typo__label" style="text-align: center;">Número de copias:</label>
                                    <v-text-field v-model="copias"
                                                  maxlength="2"
                                                  outlined
                                                  dense
                                                  @keypress="filter($event)"
                                                  @keydown.enter.prevent
                                                  :rules="[rules.required, rules.numero]">
                                    </v-text-field>
                                </vs-list>
                                <vs-list>
                                    <div>
                                        <label class="typo__label" style="text-align: center;">Fecha Inicio:</label>
                                        <div class="d-inline accent-4">
                                            <v-menu ref="menu"
                                                    v-model="menu"
                                                    :close-on-content-click="false"
                                                    transition="scale-transition"
                                                    offset-y
                                                    maxlength="16"
                                                    min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field v-model="fecha"
                                                                  outlined
                                                                  dense
                                                                  v-bind="attrs"
                                                                  readonly
                                                                  :rules="[rules.required]"
                                                                  v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="date"
                                                               locale="es-mx"
                                                               @input="menu = false">
                                                </v-date-picker>
                                            </v-menu>
                                        </div>
                                        <label class="typo__label" style="text-align: center;">Fecha Termino:</label>
                                        <div class="d-inline">
                                            <v-menu ref="menu2"
                                                    v-model="menu2"
                                                    :close-on-content-click="false"
                                                    transition="scale-transition"
                                                    offset-y
                                                    maxlength="16"
                                                    min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field v-model="fechafin"
                                                                  outlined
                                                                  dense
                                                                  v-bind="attrs"
                                                                  readonly
                                                                  :rules="[rules.required]"
                                                                  v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="datefin"
                                                               locale="es-mx"
                                                               @input="menu2 = false">
                                                </v-date-picker>
                                            </v-menu>
                                        </div>
                                    </div>
                                </vs-list>
                                <vs-list>
                                    <label class="typo__label" style="text-align: center;">Aseguradora:</label>
                                    <multiselect v-model="busqueda.aseguradora" deselect-label="No se puede remover el valor seleccionado"
                                                 selected-label="Seleccionado" select-label="Seleccionar valor"
                                                 track-by="clclave" label="clnombre" placeholder="Seleccionar Aseguradora"
                                                 :options="aseguradoras" :allow-empty="false"
                                                 @input="ObtenerFlotilla()">
                                    </multiselect>
                                    <span style="color: red;" v-show="validaaseg">Selección requerida</span>
                                </vs-list>
                                <vs-list>
                                    <label class="typo__label" style="text-align: center;">Flotillas:</label>
                                    <multiselect v-model="busqueda.flotilla" deselect-label="No se puede remover el valor seleccionado"
                                                 selected-label="Seleccionado" select-label="Seleccionar valor"
                                                 track-by="flclave" label="flnomcorto" placeholder="Seleccionar Flotilla"
                                                 :options="flotillas" :allow-empty="false">
                                    </multiselect>
                                    <!--<span style="color: red;" v-show="validaflo">Selección requerida</span>-->
                                </vs-list>
                                <vs-list>
                                    <label class="typo__label" style="text-align: center;">Razón Social:</label>
                                    <v-text-field v-model="razonsocial"
                                                  maxlength="300"
                                                  outlined
                                                  dense>
                                    </v-text-field>
                                </vs-list>
                                <vs-list>
                                    <label class="typo__label" style="text-align: center;">Abogados nombrados en el poder:</label>
                                    <multiselect v-model="busqueda.abogado" deselect-label="No se puede remover el valor seleccionado"
                                                 selected-label="Seleccionado" select-label="Seleccionar valor"
                                                 track-by="prclave" label="prnombre" placeholder="Seleccionar Abogado"
                                                 :options="abogados" :allow-empty="true" :multiple="true">
                                    </multiselect>
                                    <span style="color: red;" v-show="validaabo">Selección requerida</span>
                                </vs-list>
                                <vs-list>
                                    <label class="typo__label" style="text-align: center;">Observaciones:</label>
                                    <v-textarea :counter="600"
                                                outlined
                                                v-model="observacion"
                                                required
                                                name="input-7-4"></v-textarea>
                                </vs-list>
                                <vs-list>


                                    <span style="text-align: center">Selecciona archivo</span>
                                    <vue2Dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"
                                                  @vdropzone-sending="sendingParameters" @vdropzone-files-added="addedFiles"
                                                  @vdropzone-max-files-exceeded="maxfilesexceeded"></vue2Dropzone>
                                    <!--<span style="color: red; display: none" id="dropzError"> Debe agregar al menos un archivo </span>  @vdropzone-complete="completeQueue()"-->
                                </vs-list>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="text-center">
                                <v-btn class="ma-2"
                                       @click="Guardar()"
                                       color="primary">
                                    Guardar
                                    <template v-slot:loader>
                                        <span>Loading...</span>
                                    </template>
                                </v-btn>
                                <v-btn class="ma-2" @click="Limpiar()" color="default">
                                    Limpiar
                                </v-btn>
                                <v-btn class="ma-2" @click="Cancelar()" color="error">
                                    Regresar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-row>
        
    </v-container>
</template>
<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import Menu from '@/components/pages/operacion/MenuEstadisticas/Menu.vue';
    import General from "@/services/Operacion/Operacion.service.js";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    import vue2Dropzone from "vue2-dropzone";

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            Menu,
            vue2Dropzone,
        },
        data() {
            return {
                validForm: true,
                showcargando: true,
                rules: {
                    required: value => !!value || 'Campo requerido',
                    numero: value => value > 0 || 'El número debe ser mayor a 0',
                },
                rulestextarea: [
                    v => !!v || 'Campo requerido',
                    v => {
                        if (v == null) {
                            return true
                        }
                        else {
                            if (v.length < 12) {
                                return 'Mínimo 12 Carácteres'
                            }

                            else
                                return true
                        }
                    },
                ],
                menu: false,
                menu2: false,
                date: '',
                datefin: '',
                fecha: '',
                fechafin: '',
                minfecha: '',
                escritura: '',
                copias: '',
                observacion: '',
                razonsocial: '',
                abogadopoder: '',
                busqueda: {
                    aseguradora: '',
                    flotilla: '',
                    abogado: '',
                },
                aseguradoras: [],
                flotillas: [],
                abogados: [],
                rulesf: [
                    v => !!v || 'Archivo requerido',
                    v => {
                        if (v == null) {
                            return true
                        }
                        else {
                            return true
                        }
                    },
                ],
                files: null,
                validaaseg: false,
                validaflo: false,
                validaabo: false,
                fileChunked: false,
                dropzoneOptions: {
                    paramName: "file",
                    maxFiles: 1,
                    url: `${this.$store.state.domain.domainNameForApi}/Operacion/SubirPoder`,
                    thumbnailWidth: 200,
                    acceptedFiles: "application/pdf,",
                    autoProcessQueue: false,
                    chunkSize: 20 * Math.pow(2, 20),//5242880, // 5 MB
                    chunking: true,
                    forceChunking: true,
                    parallelUploads: 1,
                    uploadMultiple: false,
                    parallelChunkUploads: false,
                    timeout: null,
                    addRemoveLinks: true,
                    dictRemoveFile: 'Eliminar',
                    dictDefaultMessage: '<span class="dropzone-divided-message"> <span class="dropzone-bold-large">Seleccione sus archivos.</span><br>Arrastre aquí sus archivos.</span>',
                    
                    dictInvalidFileType: "No puedes subir archivos de este tipo",
                    init: function () {
                        this.on("error", function (file, errorMessage) {
                            if (errorMessage === "No puedes subir archivos de este tipo") {
                                this.removeFile(file);
                            }
                            else if (errorMessage === "You can not upload any more files.") {
                                this.removeFile(file);
                            }
                        });
                    },
                   
                },
                xhrResponses: [],
                uploadStatus: true,
                filesToSend: 0,
                filesSended: 0,
                validDocs: null,
            }
        },
        watch: {
            'busqueda.aseguradora'(val) {
                if (this.busqueda.aseguradora != '')
                    this.validaaseg = false;
            },
            'busqueda.flotilla'(val) {
                if (this.busqueda.flotilla != '')
                    this.validaflo = false;
            },
            'busqueda.abogado'(val) {
                if (this.busqueda.abogado != '')
                    this.validaabo = false;
            },
            date(val) {

                this.fecha = this.formatDate(this.date);

                if (moment(this.date) > moment(this.datefin))
                    this.fechafin = '';
            },
            datefin(val) {
                this.fechafin = this.formatDate(this.datefin);
                if (moment(this.date) > moment(this.datefin))
                    this.fecha = '';
            },
        },
        methods: {
            
            maxfilesexceeded(file) {
            },
            addedFiles() {
                //document.getElementById("dropzError").style.display = "none";
            },
            async startFileUpload() {
                let tempQueue = this.$refs.myVueDropzone.getQueuedFiles();
                if (tempQueue.length == 0) {
                    this.disabledSave = false;
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: "Llene los datos correctamente",
                        html: "Por favor adjunte al menos 1 documento",
                        showConfirmButton: true,
                    });
                } else {
                    this.filesToSend = tempQueue.length;
                    this.$refs.myVueDropzone.processQueue();
                }
            },

            async sendingParameters(file, xhr, formData) {
                this.xhrResponses.push(xhr);
                formData.append("numescritura", this.escritura);
                formData.append("filename", file.name);
            },

            async successFile() {
                let jsonData = JSON.parse(this.xhrResponses[0].response);
                this.xhrResponses = [];
                this.contador = 0;
                this.completeQueue();
                this.$refs.myVueDropzone.removeAllFiles();
            },

            completeQueue(file, xhr, formData) {
                this.$refs.myVueDropzone.removeAllFiles();

            },

            async Guardar() {
                if (this.escritura != '')
                    await this.ValidarNum();
                let tempQueue = this.$refs.myVueDropzone.getQueuedFiles();
                this.validDocs = tempQueue.length == 0 ? false : true;
                
                if (this.busqueda.aseguradora == '') {
                    this.validaaseg = true;
                }

                if (this.busqueda.abogado == '')
                    this.validaabo = true;

                if (this.$refs.form.validate() /*&& this.validDocs*/ && this.validaaseg == false && this.validaabo == false) {
                    let formData = new FormData();
                    formData.append("abogados", JSON.stringify(this.busqueda.abogado));
                    formData.append("podnumescritura", this.escritura);
                    formData.append("podnumcopia", this.copias);
                    formData.append("podfhinivig", this.date);
                    formData.append("podfhfinvig", this.datefin);
                    formData.append("clclave", this.busqueda.aseguradora != '' ? this.busqueda.aseguradora.clclave : null);
                    formData.append("flclave", this.busqueda.flotilla != '' ? this.busqueda.flotilla.flclave : null);
                    formData.append("podobserv", this.observacion);
                    formData.append("fileToUpload", this.files);
                    formData.append("podrazonsocial", this.razonsocial);
                    this.$swal({
                        position: "center",
                        title: "Procesando Guardando ...",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        confirm: false,
                    });
                    this.$swal.showLoading();
                    await General.GuardarPoderes(this, formData).then(data => {
                        if (data) {
                            if (this.validDocs)
                                this.startFileUpload();
                            this.$swal({
                                position: "center",
                                icon: "success",
                                title: "Éxito!",
                                html: "Se agregó de manera exitosa el alta de poderes",
                                confirmButtonText: "Aceptar",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.$router.push({ name: 'BusquedaPoderes' });
                                    //this.Limpiar();
                                }
                            });
                            
                        }
                        else {
                            this.$swal({
                                position: "center",
                                icon: "error",
                                title: "Error!",
                                html: "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                confirmButtonText: "Aceptar",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            }).then((result) => {
                                
                            });
                        }
                    });
                }
            },
            Cancelar() {
                this.$router.push({ name: 'BusquedaPoderes' });
            },
            Limpiar() {
                this.busqueda.aseguradora = '';
                this.busqueda.flotilla = '';
                this.busqueda.abogado = '';
                this.date = '';
                this.datefin = '';
                this.validaaseg = false;
                this.validaflo = false;
                this.validaabo = false;
                this.$refs.form.reset();
                this.$refs.myVueDropzone.removeAllFiles();
            },
            async ValidarNum() {
                let form = new FormData();
                form.append("numero", this.escritura);
                await General.ValidarNum(this, form).then(data => {
                    if (data == 1) {
                        this.$swal(
                            "Atención",
                            "El número de escritura ya existe. Verifíquelo de nuevo",
                            "info"
                        );
                        this.escritura = '';
                    }
                });
            },
            filter: function (evt) {
                evt = (evt) ? evt : window.event;
                let expect = evt.target.value.toString() + evt.key.toString();

                if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            async ListadoProveedor() {
                await General.ListadoProveedor(this).then(data => {
                    this.abogados = data;
                });
            },
            async ClientesPoderes() {
                await General.ClientesPoderes(this).then(data => {
                    this.aseguradoras = data;
                });
            },
            async ObtenerFlotilla() {
                let form = new FormData();
                form.append("clclave", this.busqueda.aseguradora.clclave)
                await General.ObtenerFlotilla(this, form).then(data => {
                    this.flotillas = data;
                });
            },
            formatDate(date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            parseDate(date) {
                if (!date) return null

                const [day, month, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
        },
        computed: {
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage']),
            DRAWER_STATE: {
                get() {
                    return this.drawer
                },
            },
        },
        mounted() {
            this.minfecha = moment().format("YYYY[-]MM[-]DD");
            this.ClientesPoderes();
            this.ListadoProveedor();
            this.showcargando = false;

        },
        async beforeMount() {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '275').then(response => {
                if (response.data.length > 0) {
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }

            });
        }
    }
</script>